import * as React from "react";
const User = (props) => (
  <svg
    width={22}
    height={23}
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.1403 20.9842C16.2603 21.2442 15.2203 21.3642 14.0003 21.3642H8.00033C6.78034 21.3642 5.74035 21.2442 4.86035 20.9842C5.08035 18.3842 7.75033 16.3342 11.0003 16.3342C14.2503 16.3342 16.9203 18.3842 17.1403 20.9842Z"
      stroke="#276AA6"
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9999 1.36426H7.99995C2.99999 1.36426 1 3.36424 1 8.36421V14.3642C1 18.1441 2.13999 20.2141 4.85997 20.9841C5.07997 18.3841 7.74995 16.3341 10.9999 16.3341C14.2499 16.3341 16.9199 18.3841 17.1399 20.9841C19.8599 20.2141 20.9999 18.1441 20.9999 14.3642V8.36421C20.9999 3.36424 18.9999 1.36426 13.9999 1.36426ZM10.9999 13.5342C9.01994 13.5342 7.41995 11.9242 7.41995 9.94421C7.41995 7.96423 9.01994 6.36422 10.9999 6.36422C12.9799 6.36422 14.5799 7.96423 14.5799 9.94421C14.5799 11.9242 12.9799 13.5342 10.9999 13.5342Z"
      stroke="#276AA6"
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5799 9.94449C14.5799 11.9245 12.9799 13.5344 10.9999 13.5344C9.01991 13.5344 7.41992 11.9245 7.41992 9.94449C7.41992 7.96451 9.01991 6.3645 10.9999 6.3645C12.9799 6.3645 14.5799 7.96451 14.5799 9.94449Z"
      stroke="#276AA6"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default User;
